module.exports = __webpack_public_path__ + "static/preview1-7ef59fbd085e231e61e65b161e922fa8.jpg";